import * as React from "react"

const Footer = () => (
  <footer className="container">
    <span>
      Copyright @ 2022 <a href="https://github.com/ryanbekhen">ryanbekhen</a> |
      theme by <a href="https://codeytek.com/">Imran Sayed</a> | hosted by{" "}
      <a href="https://contabo.com/en/">CONTABO</a>.
    </span>
  </footer>
)

export default Footer
